import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import Logo from '../assets/drakes_logo.jpg';
import HiDevLogo from '../assets/Hi-Dev-Logo.png';
import EmailSignup from './EmailSignup';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <EmailSignup />

        <div className="footer-top">
          <div className="footer-logo">
            <Link to="/">
              <img src={Logo} alt="Drake's Logo" />
            </Link>
          </div>
          
          <nav className="footer-nav">
            <Link to="/">Home</Link>
            <Link to="/menu">Menu</Link>
            <Link to="/private-events">Private Events</Link>
            <Link to="/trivia">Trivia</Link>
            <Link to="/live-music">Live Music</Link>
            <Link to="/gift-cards">Gift Cards</Link>
            <Link to="/catering">Catering</Link>
            <Link to="/reservations">Reservations</Link>
            <Link to="/contact-us">Contact Us</Link>
            <Link to="/our-story">Our Story</Link>
          </nav>

          <div className="footer-hidev-logo">
            <a href="https://www.hidevmobile.com/" target="_blank" rel="noopener noreferrer">
              <img src={HiDevLogo} alt="Hi Dev Logo" />
            </a>
          </div>
        </div>

        <div className="footer-copyright">
          © Drake's 2025 All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer; 